<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="$t('locations.link_location')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('locations.link_location')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        style="max-height: 40vh"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div ref="selectRefAgencies">
              
              <AccessibleElSelect
                prop="location"
                v-model="form.location"
                :options="locations.map(dist => ({ id: dist.value, name: dist.label }))"
                id-prefix="clientlikelocation"
                :isMultiple="true"
                :isDisabled="isLoadingSelect"
              >
                <template #label>
                  {{ $t('app.locations') }}
                </template>
              </AccessibleElSelect>
              
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
        <base-button class="w-full"
          mode="secondary-phantom-blue" 
          v-if="!isAllSelected" 
          :disabled="!isLoadedData || isLoadingSelect || isEmptyList" 
          :text="$t('app.select_all')" 
          @click="handleSelectAll" 
          :loading="isLoadingSelect"
          />
        <base-button class="w-full"
        v-else :text="$t('app.unselect_all')" mode="secondary-phantom-blue"
          @click="handleUnSelectAll"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect || isEmptyList"
          />
          <div class="w-48 "></div>
        <base-button class="w-full" @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
import { getpgnsavincular } from '@/services/clients/getpgnsavincular'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default
{
  name: 'client-link-location-dialog',
  components: {
    BaseDialogButton,
    AccessibleElSelect,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: [Number, String],
      default: -1
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        location: []
      },
      locations: [],
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false
    }
  },
  mounted: async function () {
    this.isLoadedData = false
    const data = await getpgnsavincular()
    if (data.blnError === true) {
      this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
    } else {
      data.PGNS.forEach(row => {
        this.locations.push({ value: row.IdPGN, label: row.Nombre })
      })
    }
    this.isLoadedData = true
  },
  computed: {
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    isEmptyList: function () {
      return this.locations === undefined || this.locations === null || this.locations.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isAllSelected: function () {
      if (this.locations.length === this.form.location.length) return true
      else return false
    },
    role: function () {
      return this.$store.getters['auth/role'].toLowerCase()
    }
  },
  methods: {
    onExpand (value) {
      // console.log('expand OPEN')
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      // console.log('onChangeInput', 'onChangeInput')
      setTimeout(() => {
        this.heightInput = this.$refs.selectRefAgencies.clientHeight
      }, 100)
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form.location = []
    },
    apply: function () {
      this.isOpen = !this.isOpen
      this.$emit('applyDialog', this.form.location)
      this.form.location = []
    },
    handleSelectAll: async function () {
      await this.handleUnSelectAll()
      this.loadingActionSelect = true
      this.locations.forEach(element => {
        setTimeout(() => {
          this.form.location.push(element.value)
          if (this.form.location.length === this.locations.length) {
            this.loadingActionSelect = false
            this.loadingActionUnSelect = false
          }
        }, 100)
      })
    },
    handleUnSelectAll: async function () {
      this.loadingActionUnSelect = true
      const staticLength = this.form.location.length
      for (let index = 0; index < staticLength; index++) {
        setTimeout(() => {
          this.form.location.pop()
          if (this.form.location.length === 0) this.loadingActionUnSelect = false
        }, 100)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
